import { processCaptions } from 'utils/utils';

export default class ExplainerVOController {
  constructor(game) {
    this.game = game;

    this.onEnd = new Phaser.Signal();

    // set captions time
    this.locationSuffix = '_' + this.game.controller.location;
    this.cptData = this.game.cache.getJSON('vo_explainer_captions');
    this.cptData = processCaptions(this.game, this.cptData, 'vo_explainer_variable-audioatlas');
    this.cptData = processCaptions(
      this.game,
      this.cptData,
      'vo_explainer_character_trait-audioatlas'
    );
    this.cptData = processCaptions(
      this.game,
      this.cptData,
      'vo_explainer_object_trait-audioatlas',
      this.locationSuffix
    );
    this.cptData = processCaptions(this.game, this.cptData, 'vo_explainer_stars-audioatlas');
    this.processRemainingCaptions();
    this.game.springRollCaptionsPlugin.setData(this.cptData);
  }

  // update caption times
  // processCaptions(audioName, suffix = '') {
  //   const vosData = this.game.cache.getJSON(audioName);

  //   for (const key in vosData.spritemap) {
  //     if (vosData.spritemap.hasOwnProperty(key)) {
  //       const cptItem = this.cptData[key + suffix];
  //       if (!cptItem) {
  //         console.log("can't find: " + (key + suffix));
  //       } else {
  //         const cpt = cptItem[0];
  //         const vo = vosData.spritemap[key];
  //         cpt.start = 0;
  //         if (vo) {
  //           cpt.end = (vo.end - vo.start) * 1000 + 100;
  //         } else {
  //           cpt.end = 1000; // 0;
  //         }
  //       }
  //     }
  //   }
  // }

  processRemainingCaptions() {
    for (const key in this.cptData) {
      if (this.cptData.hasOwnProperty(key)) {
        if (!this.cptData[key][0].end) {
          this.cptData[key][0].start = 0;
          this.cptData[key][0].end = 0;
        }
      }
    }
  }

  init(characterId, explainerData, rating, clothId) {
    this.characterId = characterId;
    this.rating = rating;
    this.explainerData = explainerData;
    this.clothId = clothId;

    // get pattern
    this.pattern = this.getPattern(rating, explainerData.version);

    // process pattern
    for (let i = 0; i < this.pattern.length; i++) {
      for (let j = 0; j < this.pattern[i].length; j++) {
        let key = this.pattern[i][j];
        key = key.replace('{name}', characterId === 'elinor' ? 'me' : characterId);
        key = key.replace('{their}', characterId === 'elinor' ? 'my' : 'their');
        key = key.replace('{them}', characterId === 'elinor' ? 'me' : 'them');
        this.pattern[i][j] = key;
      }
    }

    //
    this.ind1 = 0;
    this.ind2 = 0;
    this.playSentence();
  }

  getPattern(rating, version) {
    const patterns = {};
    patterns.star1a = [
      ['ex_star1a_hid_{name}', 'obj_0'],
      ['ex_star1a_but_{their}', 'char_0', 'ex_star1a_made_{them}'],
      ['ex_star1a_next_time_{their}', 'char_1'],
    ];

    patterns.star2a = [
      ['ex_star2a_hid_{name}', 'obj_0'],
      ['ex_star2a_but_{their}', 'char_0', 'ex_star2a_made_{them}'],
      ['ex_star2a_next_time_{their}', 'char_1'],
    ];

    patterns.star2b = [
      ['ex_star2b_hid_{name}', 'char_0'],
      ['ex_star2b_nearly', 'obj_0'],
      ['ex_star2b_where_{them}_a'],
      ['ex_star2b_where_{them}_b', 'char_1'],
    ];

    patterns.star3a = [
      ['ex_star3a_hid_{name}', 'char_0'],
      ['ex_star3a_matches', 'obj_0', 'ex_star3a_you_hid_{them}'],
      ['ex_star3a_{them}_camouflaged'],
    ];

    // patterns.star3b = [
    //   'ex_star3b_hid_{name}',
    //   'char_0',
    //   'ex_star3b_and',
    //   'char_1',
    //   'ex_star3b_matches',
    //   'obj_0',
    //   'ex_star3b_and',
    //   'obj_1',
    //   'ex_star3b_{them}_camouflaged',
    // ];

    if (rating === 2) version = 'a'; // removing pattern '3-star-b'

    return patterns['star' + (rating + 1) + version];
  }

  /* eslint-disable max-statements */
  playSentence() {
    // prepare captions and set data
    const captions = this.pattern[this.ind1];
    const newCaptions = [];
    let start = 0;
    const len = captions.length;
    let cc = { content: '', start: 0, end: 0 };
    for (let i = 0; i < len; i++) {
      const key = captions[i];
      let voId = key;
      let addToExisting = false;
      if (key.indexOf('obj') === 0) {
        const id = key.split('_')[1];
        voId = this.explainerData.object_trait[id] + this.locationSuffix;
        addToExisting = true;
      } else if (key.indexOf('char') === 0) {
        const id = key.split('_')[1];
        voId = this.explainerData.character_trait[id];
        addToExisting = true;
      }

      const newCC = this.cptData[voId];
      if (addToExisting) {
        // add character or object name to the end of current caption
        cc.content += ' ' + newCC[0].content;
        cc.end += newCC[0].end;
        start = cc.end;
      } else {
        // add captions
        for (let j = 0; j < newCC.length; j++) {
          cc = { ...newCC[j] };
          cc.start += start;
          cc.end += start;
          newCaptions.push(cc);
        }

        start = cc.end;
      }
    }

    this.ind2 = 0;

    const data = { caption: newCaptions };
    this.game.springRollCaptionsPlugin.setData(data);
    this.game.springRollCaptionsPlugin.playCaption('caption');

    this.playVO();
  }
  /* eslint-enable */

  playSentenceOld() {
    // prepare captions and set data
    const captions = this.pattern[this.ind1];
    const cc = { content: '', start: 0, end: 0 };
    const len = captions.length;
    for (let i = 0; i < len; i++) {
      const key = captions[i];
      let voId = key;
      if (key.indexOf('obj') === 0) {
        const id = key.split('_')[1];
        voId = this.explainerData.object_trait[id] + this.locationSuffix;
      } else if (key.indexOf('char') === 0) {
        const id = key.split('_')[1];
        voId = this.explainerData.character_trait[id];
      }

      cc.content += this.cptData[voId][0].content + (i < len ? ' ' : '');
      cc.end += this.cptData[voId][0].end;
    }

    this.ind2 = 0;

    const data = { caption: [cc] };
    this.game.springRollCaptionsPlugin.setData(data);
    this.game.springRollCaptionsPlugin.playCaption('caption');

    this.playVO();
  }

  playVO() {
    const key = this.pattern[this.ind1][this.ind2];
    let voId = '';
    if (key.indexOf('obj') === 0) {
      // play object trait
      const id = key.split('_')[1];
      voId = this.explainerData.object_trait[id];
      this.game.sounds.playVO(voId, {
        spriteID: 'vo_explainer_object_trait',
        onComplete: this.handleEndVO,
        onCompleteScope: this,
      });
      // this.game.springRollCaptionsPlugin.playCaption(voId + this.locationSuffix);
    } else if (key.indexOf('char') === 0) {
      // play character trait
      const id = key.split('_')[1];
      voId = this.explainerData.character_trait[id];
      this.game.sounds.playVO(voId, {
        spriteID: 'vo_explainer_character_trait',
        onComplete: this.handleEndVO,
        onCompleteScope: this,
      });
      // this.game.springRollCaptionsPlugin.playCaption(voId);
    } else {
      // play explainer VO
      voId = key;
      this.game.sounds.playVO(voId, {
        spriteID: 'vo_explainer_variable',
        onComplete: this.handleEndVO,
        onCompleteScope: this,
      });
      // this.game.springRollCaptionsPlugin.playCaption(voId);
    }
  }

  handleEndVO() {
    if (this.ind2 === this.pattern[this.ind1].length - 1) {
      // end of the sentence
      if (this.ind1 === this.pattern.length - 1) {
        // end of sentences -> finish it
        this.game.springRollCaptionsPlugin.setData(this.cptData); // restore captions
        this.onEnd.dispatch();
      } else {
        this.ind1++;
        this.playSentence();
      }
    } else {
      // play next part of sentence
      this.ind2++;
      this.playVO();
    }
  }
}
